import * as React from "react";

export const PlusWhite = (props: any) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 6V0h2v6h6v2H8v6H6V8H0V6h6Z" fill="#fff" />
  </svg>
);
